module.exports = __webpack_public_path__ + "static/img/TMBcharacterPhotos_0001_mrIbis.39849ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/TMBcharacterPhotos_0001_mrIbis.jpg
// module id = kWqM
// module chunks = 1